/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdArrowRoundBack } from "react-icons/io";
import { css } from "@emotion/react";


const Layout = ({ children }: { children: React.ReactNode }) => {
  // サイドバー表示状態を管理するステート
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  // ハンバーガーメニュー押下時のイベントハンドラ
  const drawerEvent = () => {
    setIsSidebarVisible((prevState) => !prevState);
  };
  return (
    <div style={{ display: "flex", height: "100%" }}>
      {/* サイドバー */}
      {isSidebarVisible && (
        <aside
            style={{
                width: "240px",
                backgroundColor: "#34495e",
                color: "white",
                paddingBottom: "16px",
                paddingLeft: "16px",
                paddingRight: "16px",
            }}
        >
            <div style={{
                    height: "60px",
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <IoMdArrowRoundBack
                    onClick={drawerEvent}
                    style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        paddingRight: "20px"
                    }}
                />
                <h2>
                    メニュー
                </h2>
            </div>
            <nav>
                <div>
                    <div
                        style={{marginBottom: "20px"}}
                        onMouseEnter={() => setHoveredItem("home")}
                        onMouseLeave={() => setHoveredItem(null)}
                    >
                        <a href="/" css={[style(hoveredItem === "home")]}>ホーム</a>
                    </div>
                    <div
                        style={{marginBottom: "20px"}}
                        onMouseEnter={() => setHoveredItem("docgene")}
                        onMouseLeave={() => setHoveredItem(null)}
                    >
                        <a href="/docgen" css={[style(hoveredItem === "docgene")]}>ドキュメント生成</a>
                    </div>
                    <div
                        style={{marginBottom: "20px"}}
                        onMouseEnter={() => setHoveredItem("templates")}
                        onMouseLeave={() => setHoveredItem(null)}
                    >
                        <a href="/templates" css={[style(hoveredItem === "templates")]}>テンプレート一覧</a>
                    </div>
                </div>
            </nav>
        </aside>
      )}
      {/* メインコンテンツ */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* ヘッダー */}
        <header
          style={{
            height: "60px",
            backgroundColor: "#34495e",
            color: "white",
            display: "flex",
            alignItems: "center",
            padding: "0 16px",
          }}
        >
            {!isSidebarVisible && (
                <GiHamburgerMenu
                    onClick={drawerEvent}
                    style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        paddingRight: "20px",
                    }}
                />
            )}
            <h2>AIドキュメント生成PoC</h2>
        </header>

        {/* メイン */}
        <main style={{ flex: 1, padding: "16px" }}>{children}</main>
      </div>
    </div>
  );
};


const style = (isHovered: boolean) => [
    css`
        color: ${isHovered ? "#696969" : "white"};
        transition-property: all;
        transition-duration: 0.3s;
        transition-delay: 0s;
        transition-timing-function: ease-in;
        text-decoration: none;
    `
];

export default Layout;
